import './OrderVolumeProfileGrid.scss';
import { OrderVolumeProfileBucketedDataItem } from 'widgets/orderVolumeProfile/data/orderVolumeProfileData.ts';
import { Grid, GridApi } from '@instinet-analytics/semantic-ui-components';
import React, { useContext, useMemo } from 'react';
import AppContext from 'app/AppContext.tsx';

import { useOrderVolumeProfileDimensions } from 'widgets/orderVolumeProfile/components/dimensions.ts';
import { useWidgetGridState } from 'widgets/store/grid/useWidgetGridState.ts';
import { BucketedDataItem } from 'utils/timeseries/bucket.ts';
import {
    getOrderVolumeProfileColDefs,
    OrderVolumeProfileGridColumn,
    orderVolumeProfileGridColumnsDefinitionDictionary,
} from 'widgets/orderVolumeProfile/components/grid/columns.tsx';

const OrderVolumeProfileGrid = ({
    data,
    onGridApiSet,
}: {
    data: OrderVolumeProfileBucketedDataItem[];
    onGridApiSet: (gridApi: GridApi) => void;
}) => {
    const context = useContext(AppContext);

    const colDefs = useMemo(
        () => getOrderVolumeProfileColDefs(context),
        [context]
    );

    const { bodyHeight } = useOrderVolumeProfileDimensions();

    const { gridPropsFromState, columnDefs } = useWidgetGridState<
        BucketedDataItem,
        OrderVolumeProfileGridColumn
    >(orderVolumeProfileGridColumnsDefinitionDictionary, colDefs);

    const onGridReady = (api: GridApi) => {
        onGridApiSet(api);
    };

    return (
        <div
            className="OrderVolumeProfileGrid"
            style={{ height: bodyHeight + 'px' }}
        >
            <Grid
                className={'order-volume-profile-grid ag-theme-balham-dark'}
                columnDefs={columnDefs}
                rowData={data}
                getRowDataId={(d: BucketedDataItem) => d.midTime.toString()}
                suppressColumnVirtualisation={false}
                onGridReady={onGridReady}
                {...gridPropsFromState}
            />
        </div>
    );
};

export default OrderVolumeProfileGrid;
